import http from '@/fetch/http'
import * as types from '@/vuex/types'
import Vue from 'vue'
const state = {
  imgmodalFlag: false,
  imgmodalURL: ''
}
const actions = {
  //图片预览
  setImgmodal({commit}, flag) {
    commit('setimgmodal', flag)
  },
  setImgmodalURL({commit}, url) {
    commit('setimgmodalurl', url)
  }
}
const getters = {}
const mutations = {
  setimgmodal(state, flag) {
    if(flag == 0) {
      state.imgmodalFlag = false;
    } else if(flag == 1) {
      state.imgmodalFlag = true;
    }
  },
  setimgmodalurl(state, url) {
    state.imgmodalURL = url;
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/student/imgmodal.js